import { observer, inject } from 'mobx-react'

import { FieldContainer, Title, BulletText } from '../styled'

const SpousePlan = ({ title, contribution, investmentMix }) => {
  return (
    <FieldContainer>
      {title && <Title>{title}</Title>}
      {contribution && <BulletText>{contribution}</BulletText>}
      {investmentMix && <BulletText>{investmentMix}</BulletText>}
    </FieldContainer>
  )
}

export default inject('store')(observer(SpousePlan))
